import { render } from "./EditPointsBottomMenu.vue?vue&type=template&id=622eacfb&scoped=true"
import script from "./EditPointsBottomMenu.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./EditPointsBottomMenu.vue?vue&type=script&charset=utf-8&lang=js"

import "./EditPointsBottomMenu.vue?vue&type=style&index=0&id=622eacfb&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-622eacfb"]])

export default __exports__